import PropTypes from "prop-types";
import styles from "./index.css";

const ProductDiscount = ({ discount }) => (
  <div
    aria-hidden={true}
    className={styles.productDiscount}
  >{`-${discount}%`}</div>
);

ProductDiscount.propTypes = {
  discount: PropTypes.number.isRequired
};

export default ProductDiscount;
